import { render, staticRenderFns } from "./OverageApprovalModal.vue?vue&type=template&id=52423d15&scoped=true"
import script from "./OverageApprovalModal.vue?vue&type=script&lang=js"
export * from "./OverageApprovalModal.vue?vue&type=script&lang=js"
import style0 from "./OverageApprovalModal.vue?vue&type=style&index=0&id=52423d15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52423d15",
  null
  
)

export default component.exports